// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Aixu","title":"styles_title__3n6Px"};